import { OfficeFluidErrorType } from '@fluidx/office-fluid-types';

export interface FluidErrorInfo {
  errorType: OfficeFluidErrorType;
}

export const UnknownError = 'unknownError';
